<section class="campaign-popup-content" *ngIf="data && data.isDisplay">
    <div class="inside-content">

        <img [src]="data.image?.url" alt="{{data.image?.alt}}" *ngIf="data.image && !data.lottie && !isMobile" class="spring" />
        <img [src]="data.mobileImage?.url" alt="{{data.mobileImage?.alt}}" *ngIf="data.mobileImage && !data.lottie && isMobile" class="spring mobile-image" />

        <lottie-animation-view *ngIf="data.lottie"
                               [options]="{
                             autoplay: true,
                             loop: true,
                             path: data.lottie
                         }"
                               class="spring"></lottie-animation-view>

        <div class="content-wrapper">
            <div class="main-banner">

                <h2 [innerHTML]="data.title | sanitizeHtml"></h2>
                <h3 [innerHTML]="data.text | sanitizeHtml">
                </h3>
            </div>

            <div class="button-wrapper">
                <div class="terms" [innerHTML]="data.asterisk | sanitizeHtml">
                </div>
                <a class="default-button black" title="" id="take-me" tabindex="1" (click)="buttonClick()">{{data.buttonText}}</a>
                <a (click)="linkClick()" class="default-link" title="" id="no-thanks">{{data.linkText}}</a>
            </div>
            <span class="close-popup"  tabindex="0" (click)="closePopUp($event)"  (keydown)="closePopUp($event)"  id="close-popup" aria-label="Close popup"></span>
        </div>
    </div>
</section>